import { render, staticRenderFns } from "./index.vue?vue&type=template&id=429407c6&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {BowSection: require('/workspace/components/base/BowSection/BowSection.vue').default,BowFooter: require('/workspace/components/organisms/BowFooter/BowFooter.vue').default})
